(function () {
    'use strict';

    angular.module('accountModule', [])
           .controller('ChangePasswordController', controller);

    controller.$inject = ['$http', '$timeout', '$uibModalInstance'];

    function controller($http, $timeout, $modalInstance) {
        var vm = this;
        vm.translation = globalResources;

        vm.initialize = initialize;
        vm.passwordPattern = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,16})/;
        vm.changeOldPassword = changeOldPassword;
        vm.changeNewPassword = changeNewPassword;
        vm.changePassword = changePassword;
        vm.cancel = cancel;

        function initialize() {
            setFocusForElement('oldPassword');
        }

        function setFocusForElement(id) {
            $timeout(function () {
                var element = document.getElementById(id);
                angular.element(element).focus();
            }, 500);
        }

        function changeOldPassword() {
            $http.post('/api/Users/CheckPassword', { password: vm.oldPassword })
                .success(function (isCorrect) {
                    vm.isOldPasswordCorrect = isCorrect;

                    if (vm.isOldPasswordCorrect) {
                        setFocusForElement('newPassword');
                    }
                });
        }

        function changeNewPassword() {
            vm.isNewPasswordValid = vm.passwordPattern.test(vm.newPassword);

            if (vm.isNewPasswordValid) {
                vm.newPasswordTooltip = '';
            } else {
                buildNewPasswordTooltip();
            }
        }

        function buildNewPasswordTooltip() {
            var pattern = null;
            vm.newPasswordTooltip = '<div>' + globalResources.M.PasswordRequirements + '</div>';

            // Check length of password
            if (vm.newPassword.length >= 8 && vm.newPassword.length <= 16) {
                vm.newPasswordTooltip += '<div><span class="glyphicon glyphicon-ok text-success" />';
            } else {
                vm.newPasswordTooltip += '<div><span class="glyphicon glyphicon-remove text-danger" />';
            }
            vm.newPasswordTooltip += globalResources.M.BeBetween8And16Characters + '</div>';

            // Check lowercase character
            pattern = /(?=.*[a-z])/;
            if (pattern.test(vm.newPassword)) {
                vm.newPasswordTooltip += '<div><span class="glyphicon glyphicon-ok text-success" />';
            } else {
                vm.newPasswordTooltip += '<div><span class="glyphicon glyphicon-remove text-danger" />';
            }
            vm.newPasswordTooltip += globalResources.M.AtLeastOneLowercaseLetter + '</div>';

            // Check uppercase character
            pattern = /(?=.*[A-Z])/;
            if (pattern.test(vm.newPassword)) {
                vm.newPasswordTooltip += '<div><span class="glyphicon glyphicon-ok text-success" />';
            } else {
                vm.newPasswordTooltip += '<div><span class="glyphicon glyphicon-remove text-danger" />';
            }
            vm.newPasswordTooltip += globalResources.M.AtLeastOneUppercaseLetter + '</div>';

            // Check number character
            pattern = /(?=.*\d)/;
            if (pattern.test(vm.newPassword)) {
                vm.newPasswordTooltip += '<div><span class="glyphicon glyphicon-ok text-success" />';
            } else {
                vm.newPasswordTooltip += '<div><span class="glyphicon glyphicon-remove text-danger" />';
            }
            vm.newPasswordTooltip += globalResources.M.AtLeastOneNumber + '</div>';

            // Check special character
            pattern = /(?=.*[!@#$%^&*])/;
            if (pattern.test(vm.newPassword)) {
                vm.newPasswordTooltip += '<div><span class="glyphicon glyphicon-ok text-success" />';
            } else {
                vm.newPasswordTooltip += '<div><span class="glyphicon glyphicon-remove text-danger" />';
            }
            vm.newPasswordTooltip += globalResources.M.AtLeastOneSpecialCharacter + '</div>';
        }

        function changePassword() {
            $http.post('/api/Users/ChangePassword', { password: vm.newPassword })
                .success(function () {
                    $modalInstance.dismiss('cancel');
                });
        }

        function cancel() {
            $modalInstance.dismiss('cancel');
        }
    }
})();